import React from 'react'
import { Box, Hidden } from '@material-ui/core'
import { useStyles } from './TrendingArticlesContainer_style'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import TrendMainArticleCard from 'cards/NewsCard/TrendMainArticleCard/TrendMainArticleCard'
import ArticleListMinimalCard from 'cards/NewsCard/ArticleListMinimalCard/ArticleListMinimalCard'
import ArticlesList from 'components/ArticlesList/ArticlesList'
import Button from 'shared/components/Button/Button.jsx'
import { FormattedMessage } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const TrendingArticlesContainer = (props) => {
    const { mainArticle, minimalArticles, listArticles, mobileArticles, titleId, descriptionId, showMoreButtonArticleCategory } = props
    const classes = useStyles()

    return (
        <>
            <SectionSubTitle titleId={titleId} descriptionId={descriptionId}/>
            <Hidden smDown>
                <Box className={classes.trendArticesSection}>
                    <TrendMainArticleCard article={mainArticle} />
                    {minimalArticles &&
                        <Box className={classes.articleMinimalCardsContainer}>
                            {minimalArticles.map((article, index) => <ArticleListMinimalCard article={article} key={index} />)}
                        </Box>
                    }
                </Box>
                {listArticles &&
                    <Box className={classes.recentArticlesSection}>
                        <ArticlesList articles={listArticles} />
                    </Box>
                }
            </Hidden>
            <Hidden mdUp>
                {mobileArticles &&
                    <Box className={classes.recentArticlesSection}>
                        <ArticlesList articles={mobileArticles} />
                    </Box>
                }
            </Hidden>
            <Box className={classes.showMoreButtonBox}>
                <RouteMapLink page='student-life' articleCategory={showMoreButtonArticleCategory}>
                    <Button className={classes.showMoreButton}>
                        <FormattedMessage id='item_index.show_more_button' />
                    </Button>
                </RouteMapLink>
            </Box>
        </>
    )
}

export default TrendingArticlesContainer
